module.exports = __webpack_public_path__ + "img/ocbc-bank-img.8d11e888.png";